import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/Button';
import FormGroup from 'react-bootstrap/FormGroup';
import FormControl from 'react-bootstrap/FormControl';
import { injectIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';
import Loader from '../../Common/Loader/Loader';

import messages from '../../../locale/messages';
import validate from './validate';
import { createAdminUser } from '../../../actions/siteadmin/AdminUser/manageAdminUser';

import bt from '../../../components/commonStyle.css';
import s from './AdminUserForm.css';




class AdminUserForm extends Component {
  static defaultProps = {
    roles: []
  };
  constructor(props) {
    super(props);
  }


  handleFormSubmit = async (values) => {
    const { createAdminUser, paginationData, currentPage } = this.props;
    await createAdminUser(
      values?.id,
      values?.email,
      values?.password,
      values?.roleId,
      currentPage
    );
    !values?.id && paginationData(1);
  }


  render() {
    const { error, handleSubmit, submitting, id, roles, loading } = this.props;
    const { formatMessage } = this.props.intl;

    const rolesOption = [{ value: '', label: formatMessage(messages.selectRole) }]
    const rolesOptionFormatted = roles && roles.results && roles.results.length > 0 && roles.results.map((item) => {
      return {
        value: item.id,
        label: item.name
      }
    })
    rolesOption.push(...rolesOptionFormatted || [])

    return (
      <div className={cx('maxwidthcenter', 'empty')}>
        <form onSubmit={handleSubmit(this.handleFormSubmit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className='oneColumnGrid'>
            <Field
              name="email"
              type="text"
              component={InputFieldComponent}
              inputClass={cx(bt.formControlInput)}
              label={formatMessage(messages.emailText)}
              placeholder={formatMessage(messages.email)}
            />
            <Field
              name="password"
              type="password"
              component={InputFieldComponent}
              inputClass={cx(bt.formControlInput)}
              label={formatMessage(messages.password)}
              note={formatMessage(messages.passwordText)}
              placeholder={formatMessage(messages.password)}
            />
            <Field
              name="roleId"
              component={SelectFieldComponent}
              options={rolesOption}
              inputClass={cx(bt.formControlSelect)}
              label={formatMessage(messages.role)}
              placeholder={formatMessage(messages.email)}
            />
          </div>
          <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
            <Loader
              className={bt.btnPrimary}
              show={loading}
              label={id ? formatMessage(messages.update) : formatMessage(messages.add)}
              bsSize="large"
              type="button"
              disabled={submitting}
              buttonType='submit'
            />


          </div>
        </form>
      </div>
    )
  }
}
AdminUserForm = reduxForm({
  form: "AdminUserForm", // a unique name for this form
  validate,
})(AdminUserForm);
const selector = formValueSelector('AdminUserForm');
const mapState = (state) => ({
  id: selector(state, 'id'),
  loading: state.loader.adminUserLoading
});
const mapDispatch = {
  createAdminUser
};
export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(AdminUserForm)));